import React from 'react';
import { useEffect, useRef, useState, createRef } from 'react'
import { useParams, useNavigate,  } from 'react-router-dom'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  SIDRender,
  STableActions,
  STriggerModal,
  SMessage,
} from 'shj-components'
import config from './config';
import { Button, Form, DatePicker, Modal, message, Input, Table, Tooltip } from 'antd'
import { AddOrEditForm } from './components'
import { OnWriteOff } from '../receivableList/components/onWriteOff'
import { verifyApplyFn } from './components/verifyApply'
import { printFn } from './components/printForm'
import { TransFerForm } from './components/transferForm'
import { CollectionCountHtml } from './components/collectionCount'
import { NewCollectionCountHtml } from './components/newCollectionCount'
import {fileConfirm} from '@/utils/file'
import dayjs from 'dayjs'
import {cloneDeep} from 'lodash'
import { custAccountPrePrint, transactionJournalFindListByPage,
   transactionJournalSaveOrUpdate, transactionJournalSaveAndReceiveToAccount,
  transactionJournalComfireToAccount,transactionJournalDelete,
  transactionJournalReceiveToAccount, sendTransactionElecListByTransactionId,
  exportToExportTask, modifyTransactionAmount, addTransferApply,httpDictServTenant, 
  getEnum, comfireToAccountBatch, sendSyncKingdeeRecordMessageReqeust, findResponseForFmsListBySourceOrTargetOrderId} from '@/services/fmsServices';
export default function PaymentServiceManage(props) {
  const { confirm } = Modal;
  let [form] = Form.useForm();
  let [collectForm] = Form.useForm();
  const { id, orderId, orderNo, customerId, financialOrgCode} = props
  const history = useNavigate();
  const [openModal, setModal] = useState(false);
  const [transFerModal, setTransFerModal] = useState(false);
  const [collectionCountModal, setCollectionCountModal] = useState(false);
  const [newCollectionCountModal, setNewCollectionCountModal] = useState(false);
  const [openCollectModal, setOpenCollectModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null as any);
  const [confirmReceiptList, setConfirmReceiptList] = useState([] as any[]);
  const [comfireToAccountData, setComfireToAccountData] = useState(null as any);
  //优惠券查询
  const [couponQueryModal, setCouponQueryModal] = useState(false);
  const [couponList, setCouponList] = useState([] as any[]);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const transFerRef = createRef<any>()
  const [replaceModel, setReplaceModel] = useState({
    customerName: /\${客户名称}/, //客户名称
    receivedDate: /\${收款日期}/, //收款日期
    printDate: /\${打印日期}/, //打印日期
    buildingName: /\${楼盘名称}/, //楼盘名称
    amount: /\${收款金额}/, //收款金额
    transactionTypeName: /\${收款类型}/, //收款类型
    uppercase: /\${大写收款金额}/, //大写收款金额
    creatorName: /\${制单人}/, //制单人
    auditorName: /\${审核人}/, //审核人
    paymentMethodName: /\${收款方式}/, //收款方式
    printNo: /\${收据编号}/, //收据编号
    receivablesNum: /\${收款编号}/, //收款编号
    receiverName: /\${收款人}/, //收款人
    remark: /\${备注}/, //备注
    note: /\${备注2}/, //备注2
    companyName: /\${分公司}/,
    transactionCode: /\${收款单号}/,
    bankBranchName: /\${收款银行名称}/,
    isPrintAgain: /\${是否补打}/,
    printStateName: /\${打印状态}/,
    bizopId: /\${需求ID}/,
    contractNo: /\${合同编号}/,
    paymentAccount: /\${支付账号}/,
  });
  useEffect(() => {
    reloadFn()
  }, [id])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const { paymentMethodList, verifyStateList, stateList, transactionTypeList } = query
        query.orderAccountId = id
        if (query.receivedDate) {
          query.receivedDateStart = dayjs(query.receivedDate[0]).format('YYYY-MM-DD 00:00:00')
          query.receivedDateEnd = dayjs(query.receivedDate[1]).format('YYYY-MM-DD 23:59:59')
        }
        // 将单值转换为数组形式
        paymentMethodList && (query.paymentMethodList = [paymentMethodList]);
        verifyStateList && (query.verifyStateList = [verifyStateList]);
        stateList && (query.stateList = [stateList]);
        transactionTypeList && (query.transactionTypeList = [transactionTypeList]); 
        transactionJournalFindListByPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 右侧表格事件：
  const onAdd = () => {
    if(financialOrgCode && financialOrgCode !== ''){
      setEditData(null)
      setModal(true)
    }else{
      message.warning('请等收款详情加载完成再点击')
    }
  }
  // 查看
  const onInfo = (record = {}) => {
    setEditData(cloneDeep(record))
    setReadOnly(true)
    setModal(true)
  }
  const onEdit = (record = {}) => {
    setEditData(cloneDeep(record))
    setModal(true)
  }
  const onTransferFunds = () => {
    setEditData({orderNo, orderId, customerId})
    setTransFerModal(true)
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const onSubmit = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      // 优化日期格式化和标志设置
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.accountingDate = formatDate(values.accountingDate);
      values.receivedDate = formatDate(values.receivedDate);
      values.receivedClickDate = formatDate(values.receivedClickDate);
      values.customerReceiptFlag = values.customerReceiptFlag ? '1' : '0';
      values.creditFlag = values.creditFlag ? '1' : '0';
      values.kdOutBillNoFlag = values.kdOutBillNoFlag ? '1' : '0';
      values.orderAccountId = id
      setLoadingSubmit(true)
      transactionJournalSaveAndReceiveToAccount(values).then((res:any)=>{
        message.success(res.message || '确认收款成功')
        reloadFn()
        setLoadingSubmit(false)
        setModal(false)
      }).catch(err=>{
        setLoadingSubmit(false)
      })
    })
  }
  const onSubmitTransfe = async () => {
    try {
      const values = await transFerRef.current?.validateFields();
      console.log(values,'values')
      setLoadingSubmit(true);
      const transferData = {
        ...values,
        orderId: orderId,
        transferOutAmount: values.transferOutAmount ? values.transferOutAmount : values.canRefundAmount
      };
      const res = await addTransferApply(transferData);
      message.success(res?.message || '确认转款成功');
      reloadFn();
      setTransFerModal(false);
    } catch (err) {
      console.error('转款失败:', err);
    } finally {
      setLoadingSubmit(false);
    }
  };
  const onCollectionCount = () => {
    setCollectionCountModal(true)
  }
  const onNewCollectionCount = () => {
    setNewCollectionCountModal(true)
  }
  const onConfirmReceiptShow = (value: any) => {
    value.customerReceiptFlag = value.customerReceiptFlag === true || value.customerReceiptFlag == '1'  ? '1' : '0';
    value.creditFlag = value.creditFlag === true || value.creditFlag == '1'  ? '1' : '0';
    value.kdOutBillNoFlag = value.kdOutBillNoFlag === true || value.kdOutBillNoFlag == '1'  ? '1' : '0';
    setComfireToAccountData(value)
    setOpen(true)
    if(value?.accountingDate){
      form.setFieldsValue({confirmDate: dayjs(value?.accountingDate)})
    }
  }
  const onConfirmReceiptShowModal = ({selectedRowKeys, selectedRows}) => {
    setConfirmReceiptList(selectedRowKeys)
    setOpen(true)
  }
  const onConfirmReceipt = () => {
    form.validateFields().then(async (values: any) => {
      let confirmDate = dayjs(values.confirmDate).format('YYYY-MM-DD HH:mm:ss')
      setLoading(true)
      if(confirmReceiptList.length > 0){
        comfireToAccountBatch({
          receiptId: confirmReceiptList, 
          confirmDate,
        }).then((res)=>{
          message.success(res.message || '批量确认到账成功')
          reloadFn()
          setOpen(false)
          setLoading(false)
        }).catch(err=>{
          setLoading(false)
        })
      }else{
        transactionJournalComfireToAccount({
          ...comfireToAccountData, confirmDate, orderAccountId: id
        }).then((res)=>{
          message.success(res.message || '确认到账成功')
          reloadFn()
          setOpen(false)
          setLoading(false)
        }).catch(err=>{
          setLoading(false)
        })
      }
    })
  }
  const onReceipt = (value: any) => {
    confirm({
      title: '是否确认收款？',
      onOk() {
        transactionJournalReceiveToAccount({
          ...value,orderAccountId:id
        }).then((res:any)=>{
          message.success(res.message || '确认收款成功')
          reloadFn()
        }).catch(err=>{})
      },
    });
  }
  const onDel = (value: any) => {
    let dialog = SMessage.delete({
      onOk: () => {
        transactionJournalDelete(value.id).then((res:any)=>{
          message.success(res.message || '删除成功')
          reloadFn()
        })
        dialog?.destroy();
      },
      onCancel: () => {
        dialog?.destroy();
      },
    });
    
  }
  const onSave = () => {
    //   console.log(childRef.current?.getValue()); // 获取子组件的值
    childRef.current?.validateFields().then(async (values: any) => {
      // 优化日期格式化和标志设置
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.accountingDate = formatDate(values.accountingDate);
      values.receivedDate = formatDate(values.receivedDate);
      values.receivedClickDate = formatDate(values.receivedClickDate);
      values.customerReceiptFlag = values.customerReceiptFlag ? '1' : '0';
      values.creditFlag = values.creditFlag ? '1' : '0';
      values.kdOutBillNoFlag = values.kdOutBillNoFlag ? '1' : '0';
      values.orderAccountId = id
      setLoading(true)
      transactionJournalSaveOrUpdate(values).then((res:any)=>{
        message.success(res.message || '保存成功')
        reloadFn()
        setLoading(false)
        setModal(false)
      }).catch(err=>{
        setLoading(false)
      })
    })
  }

  const onWriteOffModal = (record: any) => {
    record.sourceBillType = 'verifySourceTypeReceipt'
    record.orderAccountId = id
    const {
      current: { reload },
    } = listRef;
    OnWriteOff({
      fn: () => {
        reload();
      },
      ...record,
    });
  };
  const verifyApplyModal = (record: any) => {
    record.sourceBillType = 'verifySourceTypeReceipt'
    const {
      current: { reload },
    } = listRef;
    verifyApplyFn({
      fn: () => {
        reload();
      },
      ...record,
    });
  };
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      //支付方式 去掉在线支付
    const paymentMethodList: any = await httpDictServTenant({
      parentKey: 'paymentMethod',
      enabled: 1,
      orderBys: [
        {
          "columnName": "sortNumber",
          "asc": true
        }
      ]
    }).then((list: any) => list.filter((item) => item.priKey !== 'onlinePay'))
    //交易类型
    const transactionFeeTypeList: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    const verifyStateList: any = await getEnum('com.shj.saas.plus.fms.enums.VerifyStateEnum')
    const receiptStateList: any = await getEnum('com.shj.saas.plus.fms.enums.PaymentsDetailStatusEnum')
      resolve({
        customerReceiptFlagList: [
          { name: '是', id: '1' },
          { name: '否', id: '0' },
        ],
        paymentMethodList,
        transactionFeeTypeList,
        verifyStateList,
        receiptStateList
      })
    })
  }
  const DX = (n: any) => {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return '数据非法';
    var unit = '京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分',
      str = '';
    n += '00';
    var p = n.indexOf('.');
    if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    return str
      .replace(/零(仟|佰|拾|角)/g, '零')
      .replace(/(零)+/g, '零')
      .replace(/零(兆|万|亿|元)/g, '$1')
      .replace(/(兆|亿)万/g, '$1')
      .replace(/(京|兆)亿/g, '$1')
      .replace(/(京)兆/g, '$1')
      .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, '$1$2零$3仟')
      .replace(/^元零?|零分/g, '')
      .replace(/(元|角)$/g, '$1整');
  };
  const print = (record: any, printState: string) => {
    custAccountPrePrint({ transactionJournalId: record.id, printState: printState })
      .then((response: any) => {
        response.printDate = dayjs(response?.printDate).format("YYYY-MM-DD HH:mm:ss")
        response.receivedDate = dayjs(response?.receivedDate).format("YYYY-MM-DD HH:mm:ss")
        response.uppercase = DX(response.amount);
        response.templateHtml = replaceAllTemplate(response.templateContent, response);
        response.printState = printState;
        response.replaceModel = replaceModel;
        printS(response);
      }).finally(() => {

      });
  };
  const replaceAllTemplate = (html: any, item: any) => {
    for (let key in replaceModel) {
      if (item[key] || item[key] === '') {
        html = html.replace(new RegExp(replaceModel[key], 'gm'), item[key] || '');
      }
      // if (key == 'receiverName' || key == 'contractNo' || key == 'paymentAccount') {
      //   html = html.replace(new RegExp(replaceModel[key], 'gm'), item[key] || '');
      // }
    }
    return html;
  };
  const printS = (obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    printFn({
      fn: () => {
        reload();
      },
      ...obj,
    });
  };
  const onTransfer = () => {
    history('/fms/paymentService/transferInquiry/' + orderId);
  };
  const sendReceipt = (record: any) => {
    message.loading({ content: '发送中...' })
    sendTransactionElecListByTransactionId(record.id).then((res:any)=>{
      message.success(res.message || '发送成功')
      reloadFn()
    })
  }
  //下载收据信息
  const downReceipt = (record: any) => {
    // 以前直接下载
    // window.open(removeExtraSlashes(`${baseURL}${UrlConfig.PlusFmsWeb.DownloadTransactionElecList}?transactionId=${record.id}&Authorization=${getToken()}`));
    // 走下载中心
    message.loading({ content: '导出中' })
    exportToExportTask({transactionId:record.id}).then((res)=>{
      if (res.status) {
        message.destroy()
        fileConfirm()
      } else {
        message.error('下载失败')
        message.destroy()
      }
    })
  };
  const removeExtraSlashes = (str) => {
    // 使用正则表达式匹配一个或多个斜杠，并用一个斜杠替换它们
    return str.replace(/\/{2,}/g, '/');
  }
  //优惠券查询
  const onCouponQuery = () => {
    findResponseForFmsListBySourceOrTargetOrderId({sourceOrTargetOrderId:orderId}).then((res)=>{
      setCouponList(res)
      setCouponQueryModal(true)
    })
  }
  const modifyAmount = (record: any) => {
    setOpenCollectModal(true)
    record.amountOld = record.amount
    collectForm.setFieldsValue({...record})
  }
  const onConfirmModifyAmount = () => {
    collectForm.validateFields().then(async (values: any) => {
      setLoading(true)
      modifyTransactionAmount(values).then((res)=>{
        message.info(res?.message || '修改成功');
        setOpenCollectModal(false)
        reloadFn()
        setLoading(false)
      }).catch(err=>{
        setLoading(false)
      })
    })
  }
  // 重发金蝶
  const kdReceiptCreateMsgLog = (record: any) => {
    sendSyncKingdeeRecordMessageReqeust({syncKingdeeRecordIdList: [record.kdReceiptCreateId]}).then((res)=>{
      message.success(res?.message || '重发金蝶成功');
      reloadFn() 
    })
  };
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  const couponColumns = [
    {
      title: '优惠券名称',
      dataIndex: 'couponName',
      key: 'couponName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '来源订单号',
      dataIndex: 'sourceOrderNo',
      key: 'sourceOrderNo',
      width: 150,
      ellipsis: true,
    },
    {
      title: '受益订单号 ',
      dataIndex: 'targetOrderNo',
      key: 'targetOrderNo',
      width: 160,
      ellipsis: true,
    },
    {
      title: '优惠券ID',
      dataIndex: 'couponId',
      key: 'couponId',
      width: 160,
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'couponStatusName',
      key: 'couponStatusName',
      width: 100,
    },
    {
      title: '预计抵扣金额',
      dataIndex: 'deductionValue',
      key: 'deductionValue',
      width: 120,
    },
    {
      title: '实际抵扣金额',
      dataIndex: 'useValue',
      key: 'useValue',
      width: 120,
    },
    {
      title: '生效日期',
      dataIndex: 'effectiveTime',
      key: 'effectiveTime',
      render: (text: any) => text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : '',
      width: 120,
    },
    {
      title: '使用日期',
      dataIndex: 'useTime',
      key: 'useTime',
      render: (text: any) => text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : '',
      width: 120,
    },
  ]
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onTransferFunds, onTransfer, onCollectionCount, onNewCollectionCount, onConfirmReceiptShowModal, onCouponQuery},
    getCheckboxProps: (item)=>({
      disabled: item.state !== 'receiveToAccount'
    }),
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onInfo(record)} copy={false}></SIDRender>
        )
      },
      kdReceiptOperate(text: string, record: object) {
        return (
          <Tooltip title={text} overlayStyle={{ minWidth: '100px', maxWidth: '1000px' }}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                width: '200px',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {text}
            </div>
          </Tooltip>
        );
      },
      receiptFlagOperate(text: any, record: any) {
        return text ? '是' : '否'
      },
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn auth="PaymentDetailsWriteOff" onClick={() => onWriteOffModal(record)} disabled={!(record.state !== 'notConfirmToAccount' && record.unverifiedAmount != 0)}>核销</SActionBtn>
            <SActionBtn auth="PaymentDetailsEdit" onClick={() => onEdit(record)}>编辑</SActionBtn>
            {
              record.verifiedAmount != 0 ?  <SActionBtn auth="PaymentDetailsVerifyApplyModal" onClick={() => verifyApplyModal(record)}>核销查询</SActionBtn>:null
            }
            {
              record.state === 'notConfirmToAccount' ? <SActionBtn auth="PaymentDetailsReceipt" onClick={() => onReceipt(record)}>确认收款</SActionBtn> : null
            }
            {
              record.state === 'receiveToAccount' ? <SActionBtn auth="PaymentDetailsConfirmReceipt" onClick={() => onConfirmReceiptShow(record)}>确认到账</SActionBtn> : null
            }
            {/* <SActionBtn onClick={() => onTransfer(record)}>转款查询</SActionBtn> */}
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn auth="PaymentDetailsCustomerCopyPrint" onClick={() => print(record, 'customerCopyPrint')}>打印客户联</SActionBtn>:null
            }
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn auth="PaymentDetailsAccountCopyPrint" onClick={() => print(record, 'accountCopyPrint')}>打印记账联</SActionBtn>:null
            }
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn auth="PaymentDetailsSendReceipt" onClick={() => sendReceipt(record)}>发送收据信息</SActionBtn>:null
            }
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn onClick={() => downReceipt(record)}>下载收据信息</SActionBtn>:null
            }
            {
              record.state === 'notConfirmToAccount' || record.verifyState === 'verifyStateFinishedVerify' ? null : <SActionBtn auth="PaymentDetailsModifyAmount" onClick={() => modifyAmount(record)}>修改收款金额</SActionBtn>
            }
            {
              record.kdReceiptCreateStatus === 'E' ? <SActionBtn auth="ReceiptCreateMsgLog" onClick={() => kdReceiptCreateMsgLog(record)}>重发金蝶收款信息</SActionBtn> : null
            }
            {
              record.state === 'notConfirmToAccount' || record.verifyState === 'verifyStateNoVerify' ? <SActionBtn auth="PaymentDetailsDel" danger onClick={() => onDel(record)}>
                删除
              </SActionBtn> : null
            }
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} tableType="antd" ref={listRef} {...extension} 
        searchMode="group"
        summary={() => {
          const dataSource = listRef.current?.getDataSource() || [];
          if (dataSource.length === 0) {
            return null; // 没有数据时不显示 Table.Summary
          }

          const totalAmounts = dataSource.reduce(
            (totals, record) => {
              totals.receivable += parseFloat(record.amount) || 0;
              totals.verified += parseFloat(record.verifiedAmount) || 0;
              totals.unverified += parseFloat(record.unverifiedAmount) || 0;
              return totals;
            },
            { receivable: 0, verified: 0, unverified: 0 }
          );

          const formatAmount = (amount) => Number(amount).toFixed(2);

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}>合计</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  {formatAmount(totalAmounts.receivable)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  {formatAmount(totalAmounts.verified)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                  {formatAmount(totalAmounts.unverified)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
      {/* 优惠券查询 */}
      <SDrawer
        title={'优惠查询'}
        width="70%"
        isHideResetBtn={false}
        footer={[]}
        open={couponQueryModal}
        onClose={() => setCouponQueryModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <Table
          columns={couponColumns}
          dataSource={couponList}
          pagination={false}
          size="small"
          scroll={{ x: 1000 }}
        />
      </SDrawer>
      {/* 新增弹出抽屉层 */}
      <SDrawer
        title={editData ? '编辑' : '新增'}
        width="50%"
        isHideResetBtn={false}
        footer={[
          <Button onClick={onSave} loading={loading} disabled={loadingSubmit}>保存</Button>,
          <Button type='primary' loading={loadingSubmit} style={{ marginLeft: 10 }} disabled={(editData && editData?.state !== 'notConfirmToAccount') || loading} onClick={onSubmit}>保存并确认收款</Button>
        ]}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <AddOrEditForm ref={childRef} editData={editData} financialOrgCode={financialOrgCode} />
      </SDrawer>
       {/* 收款计算 */}
       <SDrawer
        title={'收款计算'}
        width="60%"
        isHideResetBtn={false}
        footer={[]}
        open={collectionCountModal}
        onClose={() => setCollectionCountModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <CollectionCountHtml orderId={orderId} />
      </SDrawer>
       {/* 新收款计算 */}
       <SDrawer
        title={'收款计算'}
        width="60%"
        isHideResetBtn={false}
        footer={[]}
        open={newCollectionCountModal}
        onClose={() => setNewCollectionCountModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <NewCollectionCountHtml orderId={orderId} />
      </SDrawer>
      {/* 转款 */}
      <SDrawer
        title={editData ? '转款单' : '转款单'}
        width="50%"
        isHideResetBtn={false}
        footer={[
          <Button onClick={() => setTransFerModal(false)}>取消</Button>,
          <Button type='primary' loading={loadingSubmit} style={{ marginLeft: 10 }} onClick={onSubmitTransfe}>确认转款</Button>
        ]}
        open={transFerModal}
        onClose={() => setTransFerModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <TransFerForm ref={transFerRef} editData={editData} />
      </SDrawer>
      {/* 确认到账 */}
      <STriggerModal
        title={confirmReceiptList.length > 0 ? '批量确认到账' : '确认到账'}
        cancelText="取消"
        okText="确定"
        open={open}
        confirmLoading={loading}
        onOk={onConfirmReceipt}
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        <Form form={form}>
          <Form.Item label="到账日期" name="confirmDate" rules={[{ required: true }]}>
            <DatePicker showTime={{ defaultValue: dayjs()}}  />
          </Form.Item>
        </Form>
      </STriggerModal>
      {/* 修改收款金额 */}
      <STriggerModal
        title="修改收款金额"
        cancelText="取消"
        okText="确定"
        open={openCollectModal}
        confirmLoading={loading}
        onOk={onConfirmModifyAmount}
        onCancel={() => setOpenCollectModal(false)}
        destroyOnClose
      >
        <Form form={collectForm}>
        <Form.Item {...formItemLayout} label="id" name="id" style={{display: 'none'}}>
            <Input disabled/>
          </Form.Item>
          <Form.Item {...formItemLayout} label="收款单号" name="transactionCode">
            <Input disabled/>
          </Form.Item>
          <Form.Item {...formItemLayout} label="收款金额" name="amountOld">
          <Input disabled/>
          </Form.Item>
          <Form.Item {...formItemLayout} label="已核销金额" name="verifiedAmount">
          <Input disabled/>
          </Form.Item>
          <Form.Item {...formItemLayout} label="修改后金额" name="amount" rules={[{ required: true }]}>
          <Input />
          </Form.Item>
        </Form>
      </STriggerModal>
    </div>
  )
}
